// TODO: Verify

export const DATE_FORMAT = {
  CUSTOM: 'dd-MM-yyyy',
  PRIMENG: 'dd-mm-yy',
  DASHBOARD: 'dddd, DD-MM-YYYY',
  DATE_FNS: 'DD-MM-YYYY',
  FILTER_DATE: 'YYYY-MM-DD'
};



// WEBPACK FOOTER //
// /dist/src/app/app.config.ts